import type { PImage } from '../../engine/aliases'
import type { IEntity } from '../../entities/entitiesUtils'
import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import { l } from '../../lib/imports'
import { rando } from '../../lib/rando-sidecar'
import { createId } from '../../main/common'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'

export interface IVoyageSplatter extends IEntity {
  image: PImage
}

const objs: IVoyageSplatter[] = []
export function getAll() {
  return objs
}

export function createMultiple(
  numParticles: number,
  x: number,
  y: number,
  color: number,
) {
  for (let i = 0; i < numParticles; i++) {
    create(x + rando.i(-6, 6), y + rando.i(-6, 6), color)
  }
}

export function create(x: number, y: number, color: number): IVoyageSplatter {
  let frame = sprites.voyTileParticlesRound[2]
  let image = spritesUtil.createImage(
    voyageLayers.getLayers().shipSplatter,
    frame,
  )
  image.tint = color
  image.x = x
  image.y = y

  let id = createId()
  let obj: IVoyageSplatter = {
    id,
    idLoaded: -1,
    isDead: false,
    eType: 'voy-misc',
    image,
  }
  objs.push(obj)

  return obj
}

export function kill(obj: IVoyageSplatter) {
  obj.isDead = true
}
export function killAll() {
  l.forEach(objs, (c) => {
    kill(c)
  })
  removeDead()
}

export function updateAll() {
  // l.forEach(objs, (c) => {
  //   update(c)
  // })
  removeDead()
}
export function removeDead() {
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
  })
}
